import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "gfu-drawer__header"
}
const _hoisted_2 = { class: "gfu-drawer__body _flexcol" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-drawer__footer"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_portal = _resolveComponent("app-portal")

  return (_openBlock(), _createBlock(_component_app_portal, { to: "#modals" }, {
    default: _withCtx(() => [
      _createVNode(_Transition, { name: $options.transitionName }, {
        default: _withCtx(() => [
          ($props.isOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['gfu-drawer', $options.positionClassName, {'is-open': $props.isOpen}])
              }, [
                (!$props.isFilled)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "gfu-drawer__backdrop",
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onBackdropClick && $options.onBackdropClick(...args)))
                    }))
                  : _createCommentVNode("v-if", true),
                (_ctx.$slots.header)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _renderSlot(_ctx.$slots, "header")
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: _normalizeClass(['gfu-drawer__content', $options.variantClassName, {'gfu-drawer__content--fill': $props.isFilled}]),
                  "data-qa": "drawer-content"
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  (_ctx.$slots.footer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "footer")
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["name"])
    ]),
    _: 3 /* FORWARDED */
  }))
}